import React from 'react';
import { headerStatForType } from './fleetHeaderStats';

const problemToneClass = {
  critical: 'text-critical',
  warning: 'text-warning',
};

/** Общий X / N для шапки парка, сводки Оборудования и шапки школы. */
export const EquipmentHealthValue = ({ typeSummary, type, className = 'text-[1.35rem]' }) => {
  const { ok, problem, problemTone } = headerStatForType(typeSummary, type);
  return (
    <span className={`inline-flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5 leading-tight tabular-nums ${className}`}>
      <span className="text-positive">{ok}</span>
      <span className="text-muted-600">/</span>
      <span className={problemTone ? problemToneClass[problemTone] : 'text-muted-500'}>
        {problem}
      </span>
    </span>
  );
};
